import AdminLayout from "./AdminLayout";
import StudentsTableTemp from "./Tables/StudentsTableTemp";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
// import SubLoading from '../../Loading/SubLoading';


const AcceptedApplicants = ({ applications }) => {
    let newAplications;

    if (applications) {

        newAplications = applications.filter((application) => {
            return application.applicationStatus === 'accepted'
        });    

    }
    return ( 
        <AdminLayout>
            <div className="row pt-5">
                <div className="col s12 m10 l10 offfset-m1 offset-l1">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Accepted Applications</h5>
                    <div className="divider mb-5"></div>
                    {
                        newAplications && (
                            newAplications.length !== 0  ? (
                                <StudentsTableTemp data={newAplications}/>
                            ) : (
                                <h5 className="is-size-4 has-text-weight-semibold mb-2 grey-text text-darken-2">Sorry, No Data Yet !</h5>
                            )
                        )
                    } 
                </div>
            </div>
        </AdminLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state);
    return {
        applications: state.firestore.ordered.applications
    };
};
 
export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "applications", 
            },
    ])
)(AcceptedApplicants);